import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button
} from 'semantic-ui-react'

const CardProgressNoteListUX = (props: any) => {
    return(
      <div
        id="CardProgressNoteListUX-div-0">
        <div
          className="accordion ui fluid blue raised segment"
          id="CardProgressNoteListUX-div-1"
          style={{boxShadow: "none", border: "none", borderRadius: 0}}>
          
          <div
            id="CardProgressNoteListUX-div-7"
            style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            
            <label
              id="CardProgressNoteListUX-label-2"
              style={{fontSize: "1.25rem", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Progress Note" : "บันทึกความคืบหน้าอาการของผู้ป่วย"}
            </label>
            <Button
              color="blue"
              id="CardProgressNoteListUX-Button-8"
              onClick={props.onPrint}>
              {props.languageUX === "en" ? "Print Progress Note" : "พิมพ์ใบ Progress Note"}
            </Button>
          </div>
          <div
            className="ui divider"
            id="CardProgressNoteListUX-div-3">
            
          </div>
          <Table
            data={props.progressionNoteItems}
            headers="วัน-เวลาที่สร้าง,แพทย์ผู้บันทึก,Subjective,Objective,Assessment,Plan,Menu"
            id="CardProgressNoteListUX-Table-4"
            keys="last_edit,reporter,s_txt,o_txt,a_txt,p_txt,menu"
            showPagination={false}
            style={{height: "65vh"}}>
          </Table>
          <div
            id="CardProgressNoteListUX-div-9"
            style={{display: "flex", justifyContent: "flex-end", marginTop: "0.75rem"}}>
            {props.pagination}
          </div>
          <div
            id="CardProgressNoteListUX-div-5"
            style={{display: "flex", justifyContent: "flex-end", marginTop: "15px"}}>
            
            <Button
              color="green"
              disabled={props.hideButtonCreate || false}
              id="CardProgressNoteListUX-Button-6"
              onClick={props.onCreate}
              style={{display: props.hideButtonCreate ? "none" : ""}}>
              {props.languageUX === "en" ? "สร้าง Progress Note" : "บันทึกความคืบหน้าการสร้าง"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardProgressNoteListUX

export const screenPropsDefault = {"by":"order","title":"MEDICAL FEE","titleDescription":"ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"}

/* Date Time : Mon Jan 12 2026 12:15:44 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "accordion ui fluid blue raised segment"
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\", border: \"none\", borderRadius: 0}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกความคืบหน้าอาการของผู้ป่วย",
          "valueEN": "Progress Note"
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.25rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-div-3"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 1,
      "props": {
        "data": {
          "type": "code",
          "value": "props.progressionNoteItems"
        },
        "headers": {
          "type": "value",
          "value": "วัน-เวลาที่สร้าง,แพทย์ผู้บันทึก,Subjective,Objective,Assessment,Plan,Menu"
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-Table-4"
        },
        "keys": {
          "type": "value",
          "value": "last_edit,reporter,s_txt,o_txt,a_txt,p_txt,menu"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"65vh\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"15px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกความคืบหน้าการสร้าง",
          "valueEN": "สร้าง Progress Note"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.hideButtonCreate || false"
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-Button-6"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCreate"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideButtonCreate ? \"none\" : \"\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบ Progress Note",
          "valueEN": "Print Progress Note"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-Button-8"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrint"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardProgressNoteListUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"0.75rem\"}"
        }
      },
      "seq": 7,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 70,
  "isMounted": false,
  "memo": false,
  "name": "CardProgressNoteListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "by": "order",
    "title": "MEDICAL FEE",
    "titleDescription": "ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"
  },
  "width": 80
}

*********************************************************************************** */
